import {
  Box, Container,
  darken,
  Typography, useMediaQuery,
  useTheme
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core';
import clsx from "clsx";
import useCustomModal from "components/CustomConfirm";
import CustomConfirmDialog from "components/CustomConfirm/CustomConfirmDialog";
import isEmpty from "lodash.isempty";
import React, { useCallback, useEffect } from "react";
import ReactJson from "react-json-view";
import Lottie from "react-lottie-player";
import { useHistory } from "react-router-dom";
import { testLogEventWhitelabel, useUserState } from "services/authentication.service";
import { personNameFull } from "util/format";
import { useRunOnce, useState } from "util/stateref";
import { useStateRef, useUrlState } from '@zennya/web-component-library/src'
import animationData from "../../../../pages/NotFound/404.json";
import { analyticsIdentifierState, openChatState, SUPPORT_CHAT } from "pages/CustomerBooking";
import { useRecoilState, useSetRecoilState } from "recoil";
import { Chat } from "pages/CustomerBooking/Chat";
import { CustomToaster } from "components/CustomToaster";

const useStyles = makeStyles((theme) => {
  return{
  notFound: {
    width: 300,
  },
  lottieWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },

    height: "100%",
  },
  logoContainer: {
    height: 92,
    width: "100%",
    marginTop: "100px",
    position: "relative",
    marginLeft: "0px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "-10px",
    },
  },
  rootContainer: {
    height: props => {
      return `calc(100vh - ${props.bar ? theme.mixins.toolbar.minHeight : 0}px)`
    },
    backgroundColor: theme.palette.secondary.main,
    overflowY: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    width: "100vw"

  },
  container: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
  hero: {
    fontWeight: "bolder",
    [theme.breakpoints.down("sm")]: {
      fontSize: 25,
      lineHeight: "29.3px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 50,
      lineHeight: "58.59px",
    },
  },
  white: {
    color: theme.palette.common.white,
  },
  textBody: {
    fontWeight: 400,
    size: "20px",
    lineHeight: "23.44px",
  },
  block: {
    paddingBottom: "19px",
  },
  heroBlock: {
    paddingTop: "64px",
    [theme.breakpoints.down("md")]: {
      paddingTop: "30px",
    },
  },
  heroButton: {
    fontSize: "30px",
    padding: "15px 63px",
    letterSpacing: 0,
    [theme.breakpoints.down("md")]: {
      fontSize: 15,
      padding: "15px 33px",
    },
  },
  mobileStore: {
    "& > *": {
      marginRight: theme.spacing(2),
    },
  },
}
});

const BookingNotFound = ({ match, ...props }) => {
  const classes = useStyles(props);
  const history = useHistory()
  const serviceId = match?.params?.serviceId
  const { getIdentity, user, getUser, logout, doLogout, fetchBookingByAuth } = useUserState()
  const [userState, setUserState, userStateRef] = useState();
  const [analyticsIdentifier, setAnalyticsIdentifier] = useRecoilState(analyticsIdentifierState);

  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
  });


  const doSwitchAccounts = useCallback(
    async (bookingData, user) => {
      const ident = await getIdentity(user?.client?.id || user?.user?.id)
      testLogEventWhitelabel(serviceId, medium, `[client-${user?.user?.id}] tried to open unowned booking`)
      await logout(serviceId, {
        description: (<Typography>This booking is owned by another account. <br />You are currently logged in as {personNameFull(ident)} with email {ident?.email} </Typography>),
        title: 'You do not have access to this booking'
      }, null, true)
    },

    [getIdentity, logout, medium, serviceId],
  );
  const setChatOpen = useSetRecoilState(openChatState);

  const fetchAuthOrBooking = useCallback(
    async (svcId) => {
      let result
      try {
        const user = await getUser(serviceId)
        if (!(user?.client?.id || user?.user?.id)) {
          // await doLogout(serviceId, false)
          history.replace(`/bookings/login/${serviceId}` + history.location.search)

          return
        }
        const ident = await getIdentity(user?.client?.id || user?.user?.id)
        setUserState(ident)

        const bookingData = await fetchBookingByAuth(svcId, analyticsIdentifier)
        setAnalyticsIdentifier(bookingData?.client?.id)
        if (ident?.id !== bookingData?.client?.id) {
          doSwitchAccounts(bookingData, user)
        } else {
          history.replace(`/bookings/${svcId}` + history.location.search)
        }


      } catch (e) {
        logout(match?.params?.serviceId, {}, () => {
          setChatOpen(SUPPORT_CHAT)
        })
      }
    },
    [doSwitchAccounts, getUser],
  )
  useEffect(() => {
    if (!isEmpty(serviceId)) {
      fetchAuthOrBooking(serviceId)
    }
  }, [fetchAuthOrBooking, serviceId]);



  return (
    <div className={classes.rootContainer}>
      <CustomToaster
        onChatOpen={() => {
          setChatOpen(SUPPORT_CHAT)
        }}
      />
      {/* <Chat serviceId={serviceId} /> */}
      <Box className={classes.container}>
        <Lottie
          play
          loop={0}
          animationData={animationData}
          className={classes.notFound}
        />

        <Box className={clsx(classes.heroBlock, classes.block)}>
          <span className={classes.hero}>
            <span className={clsx(classes.white)}>Not Found</span>
          </span>
        </Box>
      </Box>
    </div>

  );
};


export { BookingNotFound };
